<template>
  <b-modal v-model="visible" size="lg" centered scrollable header-class="bg-modal-header" class="modal-dialog-right">
    <template #modal-header>
      <div class="fw-bold">{{ title }}</div>
    </template>

    <div class="row">
      <div class="col">
        <div class="card mb-0">
          <div class="card-body">
            <div class="row">
              <div v-if="chargerInfoType === 'broken'">
                <apexchart height="200"
                           :options="brokenReasonChartOptions" :series="brokenReasonChartSeries" />
              </div>

              <div v-else>
                <apexchart height="200"
                           :options="unusedPeriodChartOptions" :series="unusedPeriodChartSeries" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template #modal-footer>
      <div class="w-100">
        <b-button variant="secondary" class="float-end w-xs p-1" @click="visible=false">닫기</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "brokenUnusedModal",
  props: {
    chargerInfoType: String,
    brokenData: Object,
    unusedData: Object
  },
  computed: {
    title() {
      const vm = this;

      if (vm.chargerInfoType === 'broken') {
        return '고장 발생 시 트랜잭션 상태 유형'
      } else if (vm.chargerInfoType === 'unused') {
        return '기간별 미사용 충전기 수량'
      }
    }
  },
  watch: {
    chargerInfoType(val) {
      const vm = this;

      if (val === 'broken') {
        vm.updateBrokenReasonChart();
      } else if(val === 'unused') {
        vm.updateUnusedChart();
      }
    }
  },
  data() {
    return {
      visible: false,
      brokenReasonChartSeries: [],
      brokenReasonChartOptions : {
        chart: {
          type: 'bar',
          toolbar: { show: false },
          parentHeightOffset: 0,
          fontFamily: 'NanumSquareRound',
        },
        xaxis: {
          categories: [],
          tickAmount: 2,
        },
        yaxis: {
          tickAmount: 2,
          forceNiceScale: true,
          max: max => max < 5 ? 4 : Math.ceil(max / 10) * 10,
          labels: {
            formatter: val => val.toLocaleString()
          }
        },
        colors: ['#f5554a'],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '20px',
          }
        },
        dataLabels: { enabled: false },
        legend: { show: false },
        tooltip: {
          x: { show: false },
          y: {
            formatter: val => `${val.toLocaleString()}기`,
            title: {
              formatter: seriesName => '',
            },
          },
        },
        grid: {
          padding: {
            top: -20,
            right: 30,
            bottom: -10,
            left: 20
          },
        },
        states: {
          active: {
            filter: {
              type: 'none',
            }
          },
        },
        noData: {
          text: 'No Data',
          offsetY: -20,
          offsetX: 30,
          style: {
            color: '#858585',
          }
        }
      },
      unusedPeriodChartSeries: [],
      unusedPeriodChartOptions: {
        chart: {
          type: 'bar',
          toolbar: { show: false },
          parentHeightOffset: 0,
          fontFamily: 'NanumSquareRound',
        },
        colors: ['#bde513'],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '50%',
          }
        },
        dataLabels: { enabled: false },
        legend: { show: false },
        xaxis: {
          categories: ['30일 ~ 59일', '60일 ~ 89일', '90일 이상']
        },
        yaxis: {
          tickAmount: 2,
          forceNiceScale: true,
          max: max => max < 5 ? 4 : Math.ceil(max / 10) * 10,
          labels: {
            formatter: val => val.toLocaleString()
          }
        },
        tooltip: {
          x: { show: false },
          y: {
            formatter: val => `${val.toLocaleString()} 기`,
            title: {
              formatter: seriesName => '',
            },
          },
        },
        grid: {
          padding: {
            top: -20,
            right: 30,
            bottom: -10,
            left: 20
          },
        },
        states: {
          active: {
            filter: {
              type: 'none',
            }
          },
        },
        noData: {
          text: 'No Data',
          offsetY: -20,
          offsetX: 30,
          style: {
            color: '#858585',
          }
        }
      },
    }
  },

  methods: {
    show() {
      const vm = this;
      vm.visible = true;

      if (vm.chargerInfoType === 'broken') {
        vm.updateBrokenReasonChart();
      } else if(vm.chargerInfoType === 'unused') {
        vm.updateUnusedChart();
      }
    },
    updateBrokenReasonChart() {
      const vm = this;
      const categories = vm.brokenData.countByStopReason.map(ele => `${ele.stoppedReason}`);
      const series = vm.brokenData.countByStopReason.map(ele => `${ele.count}`);

      vm.brokenReasonChartSeries = [{ data: series }];
      vm.brokenReasonChartOptions = {
        ...vm.brokenReasonChartOptions,
        ...{
          xaxis: { categories: categories },
        }
      };
    },
    updateUnusedChart() {
      const vm = this;

      vm.unusedPeriodChartSeries = [{ data: vm.unusedData.ranges.map(ele => ele.count) }]
    },
  }
}
</script>

<style scoped>

</style>